/**
 * IXD 편집기 뷰 화면(`/ixd-editor/view`)의 URL 계약.
 *
 * 업로드 화면(`/ixd-editor`)은 런처로 남기고, 보고서 확인/편집 화면은 새 탭에서
 * 이 주소로 복원한다. 편집기 화면과 홈 패널이 함께 쓰므로 features 밖 순수 함수로 둔다
 * — 파라미터명이 바뀌면 고칠 곳은 여기 한 곳.
 *
 * 상대 경로를 돌려준다: `window.open` / `location.replace` / 라우터 `navigate` 가 모두 받는다.
 */
const PARAM_REPORT_ID = "reportId";
const PARAM_FILING_ID = "filingId";
const PARAM_FILENAME = "filename";

const VIEW_PATH = "/ixd-editor/view";

const withParams = (params: Record<string, string>) =>
  `${VIEW_PATH}?${new URLSearchParams(params)}`;

export const buildEditorViewUrl = (reportId: string) =>
  withParams({ [PARAM_REPORT_ID]: reportId });

/**
 * DART 공시 XBRL 열람본. 같은 뷰 페이지를 읽기 전용으로 연다.
 *
 * 파일명을 같이 싣는다 — 새 탭은 filingId 만으로 복원되는데 preview 응답에
 * 파일명이 없어서, 안 실으면 무엇을 보고 있는지 확인할 방법이 없다.
 */
export const buildFilingViewUrl = (filingId: string, filename?: string) =>
  withParams({
    [PARAM_FILING_ID]: filingId,
    ...(filename ? { [PARAM_FILENAME]: filename } : {}),
  });
